import React from 'react'
import { SecondaryButton } from '@softura/fluentuipackage'
import './SecondaryButton.scss'

interface IProps {
  iconProps?:any,
  menuIconProps?:any,
  text?: string,
  onClick?: any,
  className?: string | number,
  imgSrc?: any,
  children?: any
}
const SecondaryButtonContainer = ({
  text = '',
  className = '',
  imgSrc = null,
  onClick,
  menuIconProps = null,
  iconProps = null,
  children = null
}:IProps) => {
  return (<>
      <SecondaryButton
        text = {text}
        className = {`secondary-btn ${className}`}
        imgSrc = {imgSrc}
        onClick = {onClick}
        iconProps = {iconProps}
        menuIconProps = {menuIconProps}
      >
        {children}
      </SecondaryButton>
    </>
  )
}

export default SecondaryButtonContainer
